import { useEffect, useMemo, useState } from "react";

import { sortMobileStagesToEnd } from "../utils";
import { useSiteStages } from "react-migration/domains/sites/hooks";

export const useChangeSiteStage = () => {
  const { stages, loading, networkStatus } = useSiteStages();
  const stagesOrdered = useMemo(() => stages && [...stages].sort(sortMobileStagesToEnd), [stages]);
  const [selectedStageId, setSelectedStageId] = useState(stagesOrdered?.[0]?._id || "");
  useEffect(() => {
    if (stagesOrdered?.length) {
      setSelectedStageId(stagesOrdered[0]._id);
    }
  }, [stagesOrdered]);

  const handleChangeStage = (id: string) => {
    setSelectedStageId(id);
  };

  return {
    loading,
    networkStatus,
    selectedStageId,
    handleChangeStage,
    stagesOrdered,
  };
};
